import axios from 'axios';

const instance = axios.create({
    //baseURL: 'http://61.5.159.221:8130/'
    // baseURL:    'http://localhost:44347/'
    // baseURL: 'https://altpaymerchants.com/telematicswebapi/'
    baseURL: 'https://shelltelematics.pk/telematicswebapi/'
});

instance.defaults.headers.common['APIkey'] = 'C5BFF7F0-B4DF-475E-A331-F737424F013C';
instance.defaults.headers.common['Content-Type'] = 'application/json';
axios.interceptors.request.use(function (config) {
    console.log('Request URL:', config.url);
    console.log('Request Headers:', config.headers);
    console.log('Request:', config);
    return config;
  }, function (error) {
    console.error('Request Error:', error);
    return Promise.reject(error);
  });
  
  // Add an interceptor for response logging
  axios.interceptors.response.use(function (response) {
    console.log('Response:', response);
    return response;
  }, function (error) {
    console.error('Response Error:', error);
    return Promise.reject(error);
  });

export default instance;